import React from 'react';

import { useSerpsMatch } from '@/domain/serps/hooks';

import { CITY, ROLE } from '../../constants';
import { capitalizeFirstLetter, slugify } from '../../utils';
import { TagList } from '../tag-list';
import { useTopSubcategories } from './use-top-subcategories';

export const TopSubcategories: React.VFC = () => {
  const { employmentTypes, roles, cities } = useTopSubcategories();
  const serps = useSerpsMatch();
  const isLocalRoleSerps = serps && (serps.category === CITY || serps.category === ROLE);

  const employmentTypesFiltered = employmentTypes.filter(
    (item) => !item.id.includes('VOLUNTARY') && !item.id.includes('SEASONAL') && !item.id.includes('FULL_TIME')
  );

  const contractorEmploymentType = employmentTypesFiltered.find((item) => item.id.includes('CONTRACTOR'));
  const serpsListResults = isLocalRoleSerps ? employmentTypesFiltered : employmentTypes;

  const isLocalOnlySerp = serps?.category === CITY && !serps?.subcategory;
  if (isLocalOnlySerp && contractorEmploymentType?.link?.url) {
    contractorEmploymentType.link.url = `/jobs/freelancer-jobs-in-${slugify(serps?.categoryValue).toLocaleLowerCase()}`;
  }

  return (
    <div data-cy="serps-top-subcategories">
      <TagList headerCopyKey="XJM_TEASER_LINKS_JOB_TYPE_TITLE" serpsList={serpsListResults} />

      <TagList headerCopyKey="XJM_TEASER_LINKS_TERM_TITLE" serpsList={roles} />

      <TagList
        headerCopyKey="XJM_SEO_TOP_JOB_ROLE_LOCATIONS"
        headerCopyValues={{ role: capitalizeFirstLetter(serps?.categoryValue || '') }}
        serpsList={cities}
      />
    </div>
  );
};
